import { components, PlaceholderProps, ValueContainerProps } from 'react-select';
import React, { Children, FunctionComponent } from 'react';
import { SelectOptionData } from '@/components/SelectFloatingLabel/SelectFloatingLabel';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer: FunctionComponent<
  ValueContainerProps<SelectOptionData> & PlaceholderProps<SelectOptionData>
> = ({ children, ...props }) => {
  return (
    <ValueContainer {...props} className="  border-0 border-b-2 border-gray-200">
      <Placeholder {...props} isFocused={props.isFocused}>
        <div className="mt-0 block w-full bg-white px-0  text-gray-500 focus:border-black focus:outline-none focus:ring-0">
          {props.selectProps.placeholder}
        </div>
      </Placeholder>
      {Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return child && child.type !== Placeholder ? child : null;
        }
      })}
    </ValueContainer>
  );
};

export default CustomValueContainer;
